<template>
  <section>
    <gs-header title="Quản lý affiliate">
    </gs-header>
    <div class="padding-sm-all">
      <gs-table
        :ref="affiliateTable"
        :table-name="affiliateTable"
        data-source="affiliates"
        :data-params="filters"
        :data-sorted="sorted"
        :data-sorts="sorts"
        @remove-filter="removeFilter"
        >
        <section slot="filters">

        </section>
        <template slot-scope="datas">
          <el-table
            :data="datas.data"
            border
            style="width: 100%">
          >
            <el-table-column
                label="#"
                width="80"
              >
                <template slot-scope="scope">
                  <small v-if="dataPaginations[affiliateTable]">{{(scope.$index + 1) + ((dataPaginations[affiliateTable].current_page -1) * dataPaginations[affiliateTable].per_page)}}</small>
                </template>
              </el-table-column>

            <el-table-column
              label="Tên"
              width="200"
            >
              <template slot-scope="scope">
                <p>{{scope.row.name}}</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Email"
              width="200"
            >
              <template slot-scope="scope">
                <p>{{scope.row.email}}</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Số khách"
              width="120"
            >
              <template slot-scope="scope">
                <p class="text-blue text-right">{{scope.row.total_invite}} khách</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Số đơn"
            >
              <template slot-scope="scope">
                <p class="text-blue text-right">{{scope.row.total_shipment}} đơn</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Tiền hoa hồng"
            >
              <template slot-scope="scope">
                <p class="text-red text-right">{{scope.row.total_money | vnd}} </p>
              </template>
            </el-table-column>

            <el-table-column
              label="Tiền đã thanh toán"
              width="200"
            >
              <template slot-scope="scope">
                <p class="text-red text-right">{{scope.row.money_paymented | vnd}} </p>
              </template>
            </el-table-column>

            <el-table-column
              label="Ngày tạo"
              width="120"
            >
              <template slot-scope="scope">
                <p>{{scope.row.created_at}}</p>
              </template>
            </el-table-column>

            <el-table-column
              width="95"
            >
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline">
                     <a @click.prevent="detailRole(scope.row)" class="text-blue padding-all display-inline-block cursor-pointer"><i class="fa fa-search"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash'
import ls from 'local-storage'
import { mapGetters, mapActions } from 'vuex'
export default {

  name: 'Affiliate',

  data () {
    return {
      affiliateTable: 'affiliates',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        {key: 'created_at', name: 'Ngày tạo'}
      ]
    }
  },
  computed: {
    ...mapGetters('affiliate', ['affiliate'])
  },
  methods: {
    ...mapActions('affiliate', ['getAffiliate']),
    removeFilter () {
      this.reloadGsTable(this.affiliateTable)
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.affiliateTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.affiliateTable)
      }
    }, 300),
    detailRole (affiliate) {
      this.$router.push({name: 'request-payments', params: {id: affiliate.id}, query: {name: affiliate.name}})
    }
  },
  mounted () {
    if (ls.get('filters') && ls.get('filters')[this.affiliateTable]) {
      this.filters = ls.get('filters')[this.affiliateTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.affiliateTable)
  },
  beforeRouteEnter (to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['affiliates']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Affiliate.vue?53492266